import CardActions from '../components/CardActions';
import React, { useEffect, useState } from 'react'
import { ITableColumn, TableList } from 'src/components/table'
import { ComentarioFields } from '../types'
import { useComentarios } from '../hooks/useComentarios'
import { QueryStatus } from 'src/types'
import { DialogNuevoComentario } from './DialogNuevoComentario';
import { Button } from '@mui/material';
import { ICON_MAS } from './SharedIcons';

export const SeccionComentarios = ({ idOperacion, codSistema }: { idOperacion: number, codSistema: number }) => {

    const { comentarios, status, refetch } = useComentarios(codSistema, idOperacion)

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const columnsComentarios: ITableColumn[] = [
        { label: 'Usuario', value: ComentarioFields.DescripcionUsuario },
        { label: 'Desc Usuario', value: ComentarioFields.DescripcionUsuario },
        { label: 'Tipo', value: ComentarioFields.DescripcionComentarioTipo },
        { label: 'Comentario', value: ComentarioFields.Comentario, width: '50%' },
    ]

    useEffect(() => {
        if (!openDialog) refetch()
    }, [openDialog])

    return (
        <CardActions
            title='Comentarios'
            actions={
                <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                    Nuevo
                </Button>
            }
            tableContent
        >
            <TableList
                entityList={comentarios}
                columns={columnsComentarios}
                isLoading={status === QueryStatus.Loading}
                error={status === QueryStatus.Error}
            />
            {
                openDialog &&
                <DialogNuevoComentario
                    open={openDialog}
                    setOpen={setOpenDialog}
                    idOperacion={idOperacion}
                    codSistema={codSistema}
                />
            }
        </CardActions>
    )
}
